import * as Yup from 'yup';

export const loginFormFieldName = {
    USER_NAME: 'username',
    PASSWORD: 'password',
    TWO_FACTOR_AUTH_CODE: 'twoFactorAuthCode',
};

export const loginFormFieldLabel = {
    USER_NAME: 'Username',
    PASSWORD: 'Password',
    TWO_FACTOR_AUTH_CODE: 'Two Factor Auth Code',
};

export const getLoginFormValidation = (showTwoFactorAuthCode: boolean) => Yup.object().shape({
    username: Yup.string().required('Username cannot be empty'),
    password: Yup.string().required('Password cannot be empty'),
    twoFactorAuthCode: showTwoFactorAuthCode ? Yup.string().required('Two Factor Auth Code cannot be empty') : Yup.string(),
});
